import React from "react";
import { useSession } from "../layout/SessionContext";

const Header = ({ onAddClick }) => {
  const { hasPermission } = useSession();

  return (
    <div className=" md:px-6"  >
      <div className="flex flex-row justify-between items-center ">
        <h1 className="font-bold text-text1 whitespace-nowrap text-[24px] sm:text-[26px] md:text-[30px]">
          Referral code
        </h1>
        {hasPermission("Referral Code", "edit") && (
          <button
            className="secondary_button text-xs sm:text-sm h-8 sm:h-10 px-3 sm:px-4 flex items-center justify-center"
            onClick={onAddClick}
          >
            Add new
          </button>
        )}
      </div>
      <hr className="mb-4 border-gray-300 mt-6" />
    </div>
  );
};

export default Header;
